function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { useField } from 'formik';
import { FormLabel, FormDescription } from "../../common";

// Local Definitions
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'checkbox';

/**
 * This is the component description
 */
const Checkbox = ({
  id,
  className: userClassName,
  style,
  name,
  label,
  description,
  disabled,
  optional,
  labelColor
  // ...otherProps
}) => {
  const [field] = useField({
    name,
    type: 'checkbox'
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, label && /*#__PURE__*/React.createElement(FormLabel, {
    name: name,
    color: labelColor,
    optional: optional
    // {...otherProps}
  }, label), /*#__PURE__*/React.createElement("input", _extends({
    id: name,
    className: "input",
    type: "checkbox",
    disabled: disabled
  }, field)), /*#__PURE__*/React.createElement(FormDescription, {
    className: "s-1",
    description: description,
    name: name
  }));
};
Checkbox.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The input name (html - and Formik state)
   */
  name: PropTypes.string.isRequired,
  /**
   * The Input description to guide the user if it's not obvious
   */
  description: PropTypes.string,
  /**
   * Whether the input should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * The color of the label
   */
  labelColor: PropTypes.string,
  /**
   * The input label
   */
  label: PropTypes.string,
  /**
  * The number of columns the label should span
  */
  labelSpan: PropTypes.number,
  /**
   * The number of columns the input should span
   */
  inputSpan: PropTypes.number,
  /**
   * The number of columns the label should span on desktop
   */
  desktopLabelSpan: PropTypes.number,
  /**
   * The number of columns the input should span on desktop
   */
  desktopInputSpan: PropTypes.number,
  /**
   * Whether the input should have an optional tag
   */
  optional: PropTypes.bool
};
Checkbox.defaultProps = {
  disabled: false
};
export default Checkbox;